(function () {
	angular
		.module('trackeye')
		.factory('ResponseRewriter', ResponseRewriter);

	ResponseRewriter.$inject = ['$q', '$injector'];

	function ResponseRewriter($q, $injector) {
		var ResponseXHR = $injector.get('ResponseXHR'),
			exports = {};

		exports.response = function (config) {
			return new ResponseXHR(config);
		};

		exports.responseError = function (config) {
			var Log = $injector.get('LogService'),
				xhr = new ResponseXHR(config);

			if (!xhr.ignoreErrors()) {
				if (xhr.is50x() || xhr.BadRequest() || xhr.NotAcceptable()) {
					Log.handle('GenericXhr')(xhr);
				}
			}

			return $q.reject(xhr);
		};

		return exports;
	}
})();